import React from 'react';
import { Button } from './ui/button';
import { DownloadSimple } from '@phosphor-icons/react';

export function exportToCSV(data, filename) {
  if (!data || data.length === 0) return;
  const headers = Object.keys(data[0]);
  const csvRows = [
    headers.join(','),
    ...data.map(row => headers.map(h => {
      const val = row[h];
      if (val === null || val === undefined) return '';
      const str = typeof val === 'object' ? JSON.stringify(val) : String(val);
      return str.includes(',') || str.includes('"') || str.includes('\n') ? `"${str.replace(/"/g, '""')}"` : str;
    }).join(','))
  ];
  const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

export function ExportButton({ data, filename, label = 'Export CSV', className = '' }) {
  if (!data || data.length === 0) return null;
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={() => exportToCSV(data, filename)}
      className={`gap-1.5 text-xs ${className}`}
      data-testid="export-csv-btn"
    >
      <DownloadSimple size={14} weight="bold" />
      {label}
    </Button>
  );
}
